<template>
  <div>blog</div>
</template>

<script>
export default {

}
</script>

<style>

</style>